module.exports = __webpack_public_path__ + "media/polly.64f7ac21.mp4";